import React from 'react';

import ToggleCard from "../../cards/ToggleCard";
import SectionLayoutGrid from "../../layouts/SectionLayoutGrid";

import Col from "../../styled/grid/Col";
import {Body, Header2} from "../../styled/typography/Typography";
import {ImageLogo} from "../../styled/pages/products/header/HeaderComponents";
import {ButtonContainer, ButtonLink} from "../../styled/button/ButtonComponents";

const SolutionsHeader = ({id, title, subtitle, description, image, cards, button}) => {
    return (
        <SectionLayoutGrid customBackground="middle" id={id} customGap="true">
            <Col>
                <Header2 color="white">
                    {title}
                </Header2>
            </Col>
            <Col span={5} marginBottom="normal" grid verticalCenter center>
                <Header2 color="white" small marginBottom="small">
                    {subtitle}
                </Header2>
                <Body color="body-text">
                    {description}
                </Body>
                {button &&
                <ButtonContainer>
                    <ButtonLink to={button.link} color="primary-brand">
                        {button.name}
                    </ButtonLink>
                </ButtonContainer>
                }
            </Col>
            <Col span={7} marginBottom="normal">
                <ImageLogo src={image} className="image-for-modal"
                           alt={subtitle}/>
            </Col>
            {cards && cards.map((item) => (
                <Col key={item.id}>
                    <ToggleCard title={item.title} description={item.description}/>
                </Col>
            ))}
        </SectionLayoutGrid>
    );
};

export default SolutionsHeader;